<div class="task-form__container">
  <div class="common-container__form-container">
    <div class="common-container__mandatory-obligatory-message-form">
      <span class="common-tag__mandatory-text-asterisk">*</span>
      <span class="common-tag__mandatory-label-text-obligatory-message"
        [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
    </div>
    @if(!(genericTask && !isLanding)){
      <div class="common-section-title__gs-container-primary">
        <div class="common-section-title__gs-item-container">
          <span class="common-section-title__gs-label-text"[afTranslate]="'task-edit.task-detail'">_Detalle de la tarea</span>
        </div>
      </div>
    }
    <field-type-text-simple [field]="taskForm.taskTitle"
      [preSelectItem]="taskForm.task.title"
      (itemSelected)="itemSelectedOn($event, 'title')">
    </field-type-text-simple>
    @if (genericTask && skin !== 'icam-red') {
      <field-type-list-simple
        [field]="taskForm.taskReach"
        [preSelectItem]="taskForm.taskReach.model"
        [listValues]="taskForm.listOptionsReach"
        (itemSelected)="itemSelectedOn($event, 'reach')">
      </field-type-list-simple>
      @if (taskForm.taskReach.model === 'Evaluation') {
        <field-type-list-simple
          [field]="taskForm.taskEvaluation"
          [preSelectItem]="taskForm.task.taskEvaluationId"
          [listValues]="taskForm.evaluations"
          (itemSelected)="itemSelectedOn($event, 'taskEvaluationId')">
        </field-type-list-simple>
      }@else if (taskForm.clientListComplete && taskForm.taskReach.model === 'Client') {
        <field-type-list-simple
          [field]="taskForm.taskClient"
          [preSelectItem]="taskForm.task.taskClientId"
          [listValues]="taskForm.clients"
          [listAll]="taskForm.allClients"
          (itemSelected)="itemSelectedOn($event, 'taskClientId')">
        </field-type-list-simple>
      }
    }
    @if (taskForm.task.taskTypeId !== 7) {
      <field-type-list-simple [field]="taskForm.typeOfTask"
        [preSelectItem]="taskForm.task.taskTypeId"
        [listValues]="taskForm.typeList"
        (itemSelected)="itemSelectedOn($event, 'taskTypeId')">
      </field-type-list-simple>
    }
    <field-type-contacts
      [field]="taskForm.taskParticipants"
      [valueId]="taskForm.newValueId"
      [concept]="taskForm.concept"
      [resetCallsInput]="taskForm.resetCallsInput"
      (sendContacts)="receiveContacts($event)"
      (resetCallsEmit)="resetCallContacts()">
    </field-type-contacts>
    <div class="task-form__col-container">
      <field-type-date class="task-form__inner-col-container"
        [field]="taskForm.taskExpirationDate"
        [concept]="taskForm.concept"
        [preSelectItem]="taskForm.taskDate"
        (itemSelected)="itemSelectedOn($event, 'expirationDate')"
        (createAlert)="createTaskAlert($event)"
        [alertHour]="taskForm.task.taskTypeId === 4 ? taskForm.task.beginHour : null">
      </field-type-date>
      @if (taskForm.task.taskTypeId === 4) {
        <div class="task-form__inner-col-container">
          <field-type-time class="task-form__field-container"
            [field]="taskForm.stateStartTime"
            [preSelectItem]="taskForm.task.beginHour"
            (itemSelected)="itemSelectedOn($event, 'beginHour')">
          </field-type-time>
          <field-type-time class="task-form__field-container"
            [field]="taskForm.stateEndTime"
            [preSelectItem]="taskForm.task.endHour"
            (itemSelected)="itemSelectedOn($event, 'endHour')">
          </field-type-time>
        </div>
      }
    </div>
    @if (taskForm.task.taskTypeId === 4) {
      <field-type-text-simple [field]="taskForm.taskPlace"
        [preSelectItem]="taskForm.task.location"
        (itemSelected)="itemSelectedOn($event, 'location')">
      </field-type-text-simple>
    }
    @if (taskForm.task.taskTypeId === 6 || taskForm.task.taskTypeId === 3 || taskForm.task.taskTypeId === 1 || taskForm.task.taskTypeId === 5) {
      <field-type-switch
        [field]="taskForm.repeatPeriod"
        [small]="true"
        [preSelectItem]="taskForm.repetitionActived"
        [disabled]="isLanding || userPermissions === 'none' || task?.repeatPatternReadonly"
        (itemSelected)="itemSelectedOn($event, 'repeatPeriod')">
      </field-type-switch>
    }
    @if (taskForm.repetitionActived) {
      <div class="common-text-input__container">
        <div class="common-text-field__container-box-default">
          <div class="common-text-field__block-header">
            <label class="common-text-field__label">
              @if (taskForm.task.repeatPattern.nextRepeat !== null) {
                <span class="common-text-input__text-label">
                  <span>
                    {{('repeat-pattern.creation-next-task' | afTranslate) + ' ' + (taskForm.task.repeatPattern.nextRepeat | convertDate:'without-time')}}
                  </span>
                </span>
              }
            </label>
            @if(!taskForm.task.repeatPatternReadonly && taskForm.userPermissions !== 'none' && !isLanding){
              <div class="common-text-input__buttons-right-header">
                <button class="common-button__link"
                  (click)="modifyPattern()">
                  <span class="common-button__link-text"
                    [afTranslate]="'repeat-pattern.edit-pattern'">_Editar patrón</span>
                </button>
              </div>
            }
          </div>
          <div class="common-text-field__body-container">
            <div class="common-text-field__text-value">
              <ul>
                <li>
                  <span [afTranslate]="'repeat-pattern.repetition-rate'">_Frecuencia de repetición:</span>
                  <span> {{taskForm.repeatPattern.frecuency}}</span>
                </li>
                <li>
                  <span [afTranslate]="'repeat-pattern.moment-creation'">_Momento de la creación:</span>
                  <span> {{taskForm.repeatPattern.momentOfCreation}}</span>
                </li>
                <li>
                  <span [afTranslate]="'repeat-pattern.repeat-interval'">_Intervalo de repetición</span>
                  <span>: </span>
                  @if (taskForm.repeatPattern.selectInterval === 'no-end-date') {
                    <span [afTranslate]="'repeat-pattern.no-end-date'"></span>
                  }@else {
                    <span>{{taskForm.repeatPattern.startInterval | convertDate:'without-time'}}</span>
                    <span> - </span>
                    @if (taskForm.repeatPattern.selectInterval === 'finish-after') {
                      <span>{{taskForm.repeatPattern.finishInterval}}</span>
                    }@else if (taskForm.repeatPattern.selectInterval === 'end-interval-day') {
                      <span>{{taskForm.repeatPattern.finishInterval | convertDate:'without-time'}}</span>
                    }
                  }
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    }@else if(taskForm.task.taskTypeId === 5 && skin !== 'uk-steel-blue'){
      <div class="common-status-message__g-container-info">
        <i class="lf-icon-info-full common-status-message__icon-md"></i>
        <div class="common-status-message__g-content">
            <div class="common-status-message__g-icon-text-content">
              <div class="common-status-message__g-title-subtitle">
                <span class="common-status-message__g-subtitle"
                  [afTranslate]="'task-edit.communication-info-1'">
                </span>
                <span class="common-status-message__g-subtitle"
                  [afTranslate]="'task-edit.communication-info-2'">
                </span>
                <span class="common-status-message__g-subtitle"
                  [afTranslate]="'task-edit.communication-info-3'">
                </span>
                <span class="common-status-message__g-subtitle"
                  [afTranslate]="'task-edit.communication-info-4'">
                </span>
              </div>
            </div>
        </div>
      </div>
    }
    <field-type-rich-text-editable
      [field]="taskForm.descriptionField"
      [preSelectItem]="taskForm.task.description"
      (itemSelected)="itemSelectedOn($event, 'description')">
    </field-type-rich-text-editable>
    @if (taskForm.task.taskTypeId === 3 && taskForm.hasContacts && !isLanding) {
      <div class="common-status-message__g-container-info">
        <i class="lf-icon-info-full common-status-message__icon-md"></i>
        <div class="common-status-message__g-content">
            <div class="common-status-message__g-icon-text-content">
              <div class="common-status-message__g-title-subtitle">
                <span class="common-status-message__g-subtitle"
                  [afTranslate]="'task-form.share-document-info'">
                </span>
              </div>
            </div>
        </div>
      </div>
      @if(!isLanding){
        <field-type-list-extended [field]="taskForm.shareTypeDocumentField"
          [listValues]="taskForm.typeShareDocument"
          [preSelectItem]="taskForm.typeShareDocumentSelected"
          (itemSelected)="taskForm.typeShareDocumentSelected = $event.newValue">
        </field-type-list-extended>
      }

      @if (taskForm.typeShareDocumentSelected==='2') {
        <field-type-list-multiple
          [field]="taskForm.shareDocumentationField"
          [listValues]="taskForm.shareDocumentationList"
          [preSelectItem]="taskForm.shareDocumentationListSelected"
          (itemSelected)="itemSelectedOn($event, 'shareDocumentation')">
        </field-type-list-multiple>
      }
    }
  </div>
  @if (!isTaskClosed && taskForm.canCreate) {
    <div class="task-form__footer-container">
      @if (taskForm.task.taskTypeId === 4 && taskForm.task.taskId && taskForm.task.taskStateId !== 5) {
        <div class="task-form__footer-left-container">
          @if (taskForm.showAccept) {
            <button class="common-button__text-noborder"
              (click)="sendNotify()">
              <i class="lf-icon-notification common-icon__md"></i>
              <span class="common-button__text-title" [afTranslate]="'expanded-menu.send-reminder'"></span>
            </button>
          }
          <button class="common-button__text-noborder"
            (click)="cancelMeeting()">
            <i class="lf-icon-close-round common-icon__md"></i>
            <span class="common-button__text-title" [afTranslate]="'task-form.cancel-meeting'"></span>
          </button>
        </div>
      }
      <div class="task-form__footer-right-container">
        @if (!isLanding) {
          <button class="common-button__text-border"
            (click)="cancelCreateTask()">
            <span class="common-button__text-title" [afTranslate]="'common.cancel'">_Cancelar</span>
          </button>
        }
        @if (taskForm.showAccept || isLanding) {
          <button class="common-button__text"
            (click)="addOrEditTask()">
            <span class="common-button__text-title"
              [afTranslate]="taskForm.task.taskId ? 'common.save' : 'common.create'">_Guardar</span>
          </button>
        }
      </div>
    </div>
  }@else if (!isLanding) {
    <div class="task-form__footer-container">
      <div class="task-form__footer-right-container">
        <button class="common-button__text" (click)="cancelCreateTask()">
          <span class="common-button__text-title" [afTranslate]="'common.exit'">_Salir</span>
        </button>
      </div>
    </div>
  }
</div>
